module.exports = __webpack_public_path__ + "img/home_bnews4_3.e529e3d6.png";